import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { Mapa2Page } from './pages/Mapa2Page';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel base code
    const f = window;
    const b = document;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = b.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = b.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);
    window.fbq('init', '1209282797134007');
    window.fbq('track', 'PageView');
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/mapa2" element={<Mapa2Page data-id="element-5" />} data-id="element-4" />
      </Routes>
    </BrowserRouter>;
}